import { render, staticRenderFns } from "./StartAndEnd.vue?vue&type=template&id=20539f0b&scoped=true&"
import script from "./StartAndEnd.vue?vue&type=script&lang=js&"
export * from "./StartAndEnd.vue?vue&type=script&lang=js&"
import style0 from "./StartAndEnd.vue?vue&type=style&index=0&id=20539f0b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20539f0b",
  null
  
)

export default component.exports